import { Button, Modal } from "react-bootstrap";
import { t } from 'i18next';

const ActivationModal = (props:{
    modalActivate: boolean,
    setSeeModalActivate: Function,
    handleStatus: Function
}) => {
    return(
        <Modal show={props?.modalActivate} onHide={() => props?.setSeeModalActivate(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t("text.warning")}</Modal.Title>
            </Modal.Header>
    
            <Modal.Body>
                <div>{t("text.activation_deactivation")}</div>
            </Modal.Body>
    
            <Modal.Footer>
                <Button
                    variant="secondary"
                    className="text-uppercase"
                    style={{ borderRadius: 25 }}
                    onClick={() => props?.setSeeModalActivate(false)}
                >
                    {t('button.cancel')}
                </Button>
    
                <Button
                    variant="bg-info"
                    className="text-uppercase bg-info"
                    style={{ color: "white", borderRadius: 25 }}
                    onClick={(e)=>props?.handleStatus(e)}
                >
                    { t("button.edit")}
                </Button>
            </Modal.Footer>
        </Modal>)
}

export default ActivationModal